import { useMemo } from 'react';
import { ScrollText } from 'lucide-react';

import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { iconSize } from '@duke-hq/ui/constants/scalable';

type CourseData = {
  id: string;
  title: string;
};

export default function CourseFilterBase({
  data,
  maxSelected,
}: {
  data: CourseData[];
  maxSelected?: number;
}) {
  const { updateFilters, filters } = useFiltersContext();

  const options = useMemo(() => {
    return data.map(({ id, title }) => ({
      id,
      value: id,
      label: title,
    }));
  }, [data]);

  const selected = useMemo(() => {
    const courses = filters.courses ?? [];
    const validIds = new Set(data.map(({ id }) => id));
    return courses.filter((id) => validIds.has(id));
  }, [data, filters.courses]);

  return (
    <MultipleChoiceFilter
      items={options}
      label="Course"
      name="courses"
      onFilterChange={({ courses }) => updateFilters({ courses })}
      onlyUpdateOnChange
      variant="ghost"
      value={selected.join(',')}
      leftIcon={<ScrollText size={iconSize.md} />}
      rightIcon={undefined}
      maxSelected={maxSelected}
    />
  );
}
